import { render, staticRenderFns } from "./tracker-organizations-by-economic-activity.vue?vue&type=template&id=e39f946c&scoped=true&"
import script from "./tracker-organizations-by-economic-activity.vue?vue&type=script&lang=js&"
export * from "./tracker-organizations-by-economic-activity.vue?vue&type=script&lang=js&"
import style0 from "./tracker-organizations-by-economic-activity.vue?vue&type=style&index=0&id=e39f946c&prod&scoped=true&lang=css&"
import style1 from "./tracker-organizations-by-economic-activity.vue?vue&type=style&index=1&id=e39f946c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39f946c",
  null
  
)

export default component.exports